import { constants } from "redux/constants/redux-constants";

const initialState = {
  addCdssSuffix: false,
  cdssTitle: "",
  cdssTabThemeColor: "#5d5fef",
};

const AddCdssSuffixReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CDSS.SET_ADD_SUFFIX:
      return {
        ...state,
        addCdssSuffix: action.payload,
      };
    case constants.CDSS.UPDATE_CDSS_TITLE:
      const theme = action?.payload?.code && themeSelector(action?.payload?.code);
      return {
        ...state,
        cdssTitle: action.payload,
        cdssTabThemeColor: theme,
      };
    default:
      return state;
  }
};

const themeSelector = (text) => {
  switch (text) {
    case "CDSS_FROM_PREV_SOAP_NOTE":
      return "#496a9e";
    case "CDSS_FROM_DEMOGRAPHICS":
      return "#b5651d";
    case "CDSS_FROM_CONVERSATION":
      return "#2196F3";
    default:
      return "#5d5fef";
  }
};

export default AddCdssSuffixReducer;
